import { ICountry } from 'APIPackage/CatalogsModule/interfaces/ICountry';

import { ICountrySelectOption } from '../interfaces/ICountrySelectOption';

export const createCountrySelectOption = (country: ICountry): ICountrySelectOption => ({
  ...country,
  label: country.title,
  value: country.id,
});
